import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import CaseAuditsAPI, {
  CaseAudit,
  GetCaseAuditsResponse,
  UpsertCaseAuditsRequest,
} from "../../../api/audits";

export const fetchCaseAudits = createAsyncThunk<
  GetCaseAuditsResponse,
  string,
  { state: RootState; rejectValue: string }
>(
  "caseAudits/fetchCaseAudits",
  async (caseId, { rejectWithValue }) => {
    try {
      return await CaseAuditsAPI.get(caseId);
    } catch {
      return rejectWithValue("Failed to fetch case audits");
    }
  },
  {
    condition(caseId, { getState }) {
      return getState().caseAudits.caseId !== caseId;
    },
  },
);

export const upsertCaseAudits = createAsyncThunk<
  void,
  { caseId: string; data: CaseAudit[] },
  { rejectValue: string }
>(
  "caseAudits/upsertCaseAudits",
  async ({ caseId, data }, { rejectWithValue }) => {
    try {
      const request: UpsertCaseAuditsRequest = {
        audits: data,
      };

      await CaseAuditsAPI.upsert(caseId, request);
    } catch {
      return rejectWithValue("Failed to update case audits");
    }
  },
);